import {
  getCerealsGrowthStageTranslation as getSharedCerealsGrowthStageTranslation,
  getCropGrowthStageTranslation as getSharedCropGrowthStageTranslation
} from '@protector/entities/crop/growth-stage';
import i18n from 'config/i18n';
import type { Crop } from '@protector/utils/types';

const translate = (key: string, defaultValue: string): string => i18n.t(key, defaultValue);

export function getCerealsGrowthStageTranslation(bbch: number | string, useAbbreviation = false): string {
  return getSharedCerealsGrowthStageTranslation(translate, bbch, useAbbreviation);
}

export function getCropGrowthStageTranslation(bbch: number | string, crop: Crop, useAbbreviation = false): string {
  return getSharedCropGrowthStageTranslation(translate, bbch, crop, useAbbreviation);
}
